import { Component, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
// import { AuthService } from '../../../../services/auth.service';
import { Router } from '@angular/router';
import { SharedservicesService } from '../../services/sharedservices.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  loginEmail:any;
  usertype:any;
  loginUser: any;
  constructor(private router: Router,private ref: SharedservicesService,private http: HttpClient) {
    var userdata = JSON.parse(localStorage.getItem('customerInfo'));
      if(!userdata) {
        this.loginEmail = '';
      } else {
        this.loginEmail = userdata.email;
        var username =  this.loginEmail.toString();
        var user = username.split("@");
        this.loginUser = user[0];
        this.usertype =userdata.usertype;
      }
      // console.log(userdata); 
      setTimeout(function(){ localStorage.removeItem('customerInfo'); }, 1000*60*60);

  }
  Navigate() {
    var userdata = JSON.parse(localStorage.getItem('customerInfo'));
    if(userdata) {
      this.loginEmail = userdata.email;
      if(this.loginEmail) {
        console.log("sunny");
        this.router.navigate(['/app/dashboard']);
      } else {
        this.router.navigate(['/']);
      }
    }
  }
  
  ngOnInit() {
  
  }
  logout(){
    this.loginEmail = '';
    localStorage.removeItem('customerInfo');
    this.router.navigate(['/'],{ queryParams: {}} );
  }
}
